export const LOCALSTORAGE_KEY_PROJECT = 'project';
export const LOCALSTORAGE_KEY_BRANCH_PREFIX = 'branch-prefix';
export const LOCALSTORAGE_KEY_TITLE = 'title';
export const LOCALSTORAGE_KEY_TYPE = 'type';
export const LOCALSTORAGE_KEY_NUMBER = 'number';
